import React, { useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import {
  Paper,
  Box,
  Typography,
  Button,
  Menu,
  MenuItem,
  IconButton
} from "@mui/material";
import MenuIcon from "@mui/icons-material/MoreVert";
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%"
  },
  image: {
    width: "100%",
    height: 255,
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    [theme.breakpoints.only("sm")]: {
      height: 200,
      width: "100%"
    }
  },
  imageContainer: {
    padding: theme.spacing(1),
    width: "100%"
  },
  buttons: {
    width: "100%",
    marginTop: theme.spacing(7)
  },
  menuButton: {
    opacity: "0.5",
    marginRight: theme.spacing(-2)
  }
}));

const WidgetMenu = props => {
  const classes = useStyles();
  const { options, onMenuItemClick, data } = props;
  const [anchorEl, setAnchorEl] = useState(null);

  return (
    <>
      <IconButton
        className={classes.menuButton}
        onClick={ev => {
          setAnchorEl(ev.currentTarget);
        }}
        size="large"
      >
        <MenuIcon />
      </IconButton>
      {options && options.length > 0 && (
        <Menu
          data-qa="my-apps-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => {
            setAnchorEl(null);
          }}
        >
          {options.map(option => (
            <MenuItem
              key={option.value}
              onClick={() => {
                onMenuItemClick(option, data);
                setAnchorEl(null);
              }}
            >
              {option.label}
            </MenuItem>
          ))}
        </Menu>
      )}
    </>
  );
};

export default function AppItem(props) {
  const classes = useStyles();
  const { user, data, openApp, menuOptions, onMenuItemClick } = props;

  const canAccessMenuOptions = () => data.permanent !== true;
  const enableOptions = () => user && user.isAdmin && canAccessMenuOptions();
  return (
    <Paper className={classes.root}>
      <Box
        display="flex"
        flexDirection="column"
        zIndex={1}
        alignItems="stretch"
        height="100%"
      >
        <Box className={classes.imageContainer}>
          <div
            style={{ backgroundImage: `url("${data.img}")` }}
            className={classes.image}
          />
        </Box>
        <Box display="flex" flexDirection="column" m={3} flex={1}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            flex={1}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
              >
                <Typography variant="h4" color="textPrimary">
                  {data.title}
                </Typography>
              </Box>
              {enableOptions() && (
                <WidgetMenu
                  options={menuOptions}
                  onMenuItemClick={onMenuItemClick}
                  data={data}
                />
              )}
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              className={classes.buttons}
            >
              <Button
                key="Open App"
                variant="contained"
                color="primary"
                onClick={
                  !!openApp
                    ? openApp
                    : () => {
                        window.open(data.url, "_blank");
                      }
                }
              >
                Open App
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
}

AppItem.propTypes = {
  enableOptions: PropTypes.bool,
  data: PropTypes.object,
  menuOptions: PropTypes.arrayOf(PropTypes.object),
  onMenuItemClick: PropTypes.func
};
